import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Container } from '@mui/material';
import { CATEGORY_ICONS, DefaultCategoryIcon } from '../../components/categories';
import { CategoryPill } from '../../components/category-pill';
import { CategoryCard } from '../../components/category-card';
import { Eyebrow } from '../../components/page-primitives';
import { useSearch } from '../../hooks/use-search';
import { useHomeCategories } from './use-home-data';
/** "Browse by category" section: a horizontal pill row on mobile, a card grid on desktop. */
export const BrowseCategories = props => {
    const homeCategories = useHomeCategories();
    const { search } = useSearch();
    const categories = props.categories ?? homeCategories;
    const onSelect = props.onSelect ?? ((category) => search({ query: '', category }));
    if (categories.length === 0) {
        return null;
    }
    return (_jsxs(Container, { maxWidth: 'xl', component: 'section', children: [_jsx(Eyebrow, { sx: { mb: { xs: '0.75rem', sm: '1.125rem' } }, children: "Browse by category" }), _jsx(Box, { sx: {
                    display: { xs: 'flex', sm: 'none' },
                    flexWrap: 'nowrap',
                    overflowX: 'auto',
                    gap: '0.5rem',
                    mx: '-1rem',
                    px: '1rem',
                    pb: '0.25rem',
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none'
                }, children: categories.map(cat => (_jsx(CategoryPill, { label: cat, icon: CATEGORY_ICONS[cat] ?? DefaultCategoryIcon, onClick: () => onSelect(cat) }, cat))) }), _jsx(Box, { sx: {
                    display: { xs: 'none', sm: 'flex' },
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '0.625rem'
                }, children: categories.map(cat => (_jsx(CategoryCard, { label: cat, icon: CATEGORY_ICONS[cat] ?? DefaultCategoryIcon, onClick: () => onSelect(cat) }, cat))) })] }));
};
//# sourceMappingURL=browse-categories.js.map